export default "__VITE_ASSET__2e2b265e__"